import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function AboutDaniel() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="daniel" ref={ref} className="py-24 md:py-32 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-6" data-id="element-2">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-3">
          {/* Image placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative" data-id="element-4">
            <div className="aspect-[4/5] bg-gradient-to-br from-beige to-beige-dark rounded-3xl overflow-hidden" data-id="element-5">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-6">
                <span className="font-serif text-8xl text-gold/30" data-id="element-7">D</span>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gold/10 rounded-full -z-10" data-id="element-8" />
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-9">
            <p className="font-sans text-sm uppercase tracking-widest text-gold mb-4" data-id="element-10">
              Sobre mí
            </p>
            <h2 className="font-serif text-4xl md:text-5xl text-charcoal mb-8" data-id="element-11">
              Daniel
            </h2>

            <div className="space-y-6 mb-10" data-id="element-12">
              <div data-id="element-13">
                <h3 className="font-serif text-xl text-charcoal mb-3" data-id="element-14">
                  Mi misión
                </h3>
                <p className="font-sans text-charcoal-mid leading-relaxed" data-id="element-15">
                  Mi misión es demostrar que el dinero y la conciencia no son
                  opuestos — son aliados. Que puedes construir un negocio
                  extraordinario sin perder tu alma en el proceso.
                </p>
              </div>

              <div data-id="element-16">
                <h3 className="font-serif text-xl text-charcoal mb-3" data-id="element-17">
                  Por qué hago esto
                </h3>
                <p className="font-sans text-charcoal-mid leading-relaxed" data-id="element-18">
                  Pasé años creyendo que el éxito requería sacrificar quién era.
                  Aprendí — a veces de la manera difícil — que el verdadero
                  negocio comienza cuando te conviertes en quien necesitas ser.
                </p>
              </div>
            </div>

            <div className="space-y-6 mb-10" data-id="element-19">
              <div className="bg-cream rounded-2xl p-6" data-id="element-20">
                <h4 className="font-serif text-lg text-gold mb-2" data-id="element-21">
                  Sobre el dinero
                </h4>
                <p className="font-sans text-sm text-charcoal-mid leading-relaxed" data-id="element-22">
                  El dinero es energía. Y como toda energía, fluye hacia donde
                  hay claridad, valor y alineación.
                </p>
              </div>

              <div className="bg-cream rounded-2xl p-6" data-id="element-23">
                <h4 className="font-serif text-lg text-gold mb-2" data-id="element-24">
                  Sobre la conciencia
                </h4>
                <p className="font-sans text-sm text-charcoal-mid leading-relaxed" data-id="element-25">
                  No puedes construir un negocio más grande que tu nivel de
                  conciencia. El trabajo interior no es opcional — es la
                  estrategia.
                </p>
              </div>

              <div className="bg-cream rounded-2xl p-6" data-id="element-26">
                <h4 className="font-serif text-lg text-gold mb-2" data-id="element-27">
                  Sobre la libertad
                </h4>
                <p className="font-sans text-sm text-charcoal-mid leading-relaxed" data-id="element-28">
                  La libertad no es un destino. Es una práctica diaria de
                  elecciones alineadas.
                </p>
              </div>
            </div>

            <div className="border-t border-beige pt-8" data-id="element-29">
              <p className="font-sans text-charcoal-mid mb-6 leading-relaxed" data-id="element-30">
                Estoy construyendo el ecosistema de transformación más completo
                para emprendedores conscientes de habla hispana.
              </p>
              <div className="flex flex-wrap gap-6 text-sm text-charcoal-mid" data-id="element-31">
                <span data-id="element-32">8+ años de experiencia</span>
                <span data-id="element-33">•</span>
                <span data-id="element-34">500+ clientes</span>
                <span data-id="element-35">•</span>
                <span data-id="element-36">3 plataformas</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}